var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTwitter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7f7f7f",
    d: "M25 2C12.317 2 2 12.317 2 25s10.317 23 23 23 23-10.317 23-23S37.683 2 25 2zm11.237 18.524c.01.236.016.476.016.717C36.253 28.559 30.68 37 20.491 37c-3.128 0-6.041-.917-8.491-2.489.433.052.872.077 1.321.077 2.596 0 4.985-.884 6.879-2.37a5.55 5.55 0 0 1-5.175-3.847 5.524 5.524 0 0 0 2.502-.095 5.544 5.544 0 0 1-4.441-5.432v-.07c.747.415 1.6.665 2.509.694a5.535 5.535 0 0 1-2.464-4.611 5.52 5.52 0 0 1 .749-2.786 15.735 15.735 0 0 0 11.418 5.788 5.54 5.54 0 0 1 9.437-5.052 11.104 11.104 0 0 0 3.518-1.343 5.555 5.555 0 0 1-2.437 3.064 11.14 11.14 0 0 0 3.183-.873 11.263 11.263 0 0 1-2.762 2.869z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwitter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/twitter.d0767172085b92f15fd11aeafb3891a1.svg";